import React, { useEffect, useRef, useState } from 'react';
import { createComponent } from '@lit-labs/react';
import RepoFMCTextarea from './RepoFMCTextarea';
import PropTypes from 'prop-types';

const RepoFMCTextareaComp = createComponent({
  react: React,
  tagName: 'repo-fmc-textarea',
  elementClass: RepoFMCTextarea,
});
const RepoTextareaComp = ({ formData: initFormData, maxChar, onUpdate }) => {
  const [localTextArea, setLocalTextArea] = useState(initFormData);
  const inputRef = useRef();

  useEffect(() => {
    const handleTextUpdate = (e) => {
      const { id, value } = e.target;
      console.log('textArea in: ' + id);
      const updatedText = {
        ...localTextArea,
        text: value,
      };
      setLocalTextArea(updatedText);
      onUpdate(updatedText);
    };

    const element = inputRef.current;

    element.addEventListener('fmc-input-focused', handleTextUpdate);

    return () => {
      element.removeEventListener('fmc-input-focused', handleTextUpdate);
    };
  }, []);

  return (
    <fmc-control slug={initFormData.fieldName + '-id'} message="Update..." status="standard" fixed>
      <RepoFMCTextareaComp
        data-testid={initFormData.fieldName + 'TextArea'}
        ref={inputRef}
        slug={initFormData.fieldName + '-textAreaId'}
        required
        slot="input"
        name={initFormData.fieldName + 'TextArea'}
        status="standard"
        value={initFormData.text}
      />
      <fmc-count slot="count" message="characters remaining." limit={maxChar} validate-immediately></fmc-count>
    </fmc-control>
  );
};

RepoTextareaComp.propTypes = {
  formData: PropTypes.shape({
    fieldName: PropTypes.string,
    text: PropTypes.string,
  }),
  maxChar: PropTypes.any,
  onUpdate: PropTypes.func,
};

export default RepoTextareaComp;
